import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//import { promises } from 'dns';
import { Observable, take } from 'rxjs';
import { UserProfileModel } from 'src/app/core/models/users/user-profile.model';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { TranslationService } from 'src/app/core/services/auth/translation.service';
import { ManualService } from 'src/app/core/services/manual/manual.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { UserProFileModel } from 'src/app/core/view-models/profile';

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}
@Component({
  selector: 'app-guest-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderGuestComponent implements OnInit {
  @Input() innerPage: boolean = false;

  isAdmin?: boolean;
  item: UserProFileModel = new UserProFileModel //nr
  isPassExpired?: boolean;

  user$!: Observable<UserProfileModel>;

  language!: LanguageFlag;
  languages: LanguageFlag[] = [
    {
      lang: 'en',
      name: 'EN',
      flag: 'flag-EN'
    },
    {
      lang: 'th',
      name: 'TH',
      flag: 'flag-TH'
    }
  ];
  constructor(
    private translationService: TranslationService,
    private authService: AuthService,
    private router: Router,

    private serviceMu: ManualService,
    private profileService: ProfileService, //nr
  ) { }

  ngOnInit(): void {
    this.loadScript('assets/js/main2.js');

    this.setSelectedLanguage();
    this.handlePassExpire();

  }

  async handlePassExpire() {

    const chkLogIn = await this.authService.hasLogined()

    if (chkLogIn == true) {
      await this.setPassExpire();

      if (this.isPassExpired == false) {
        this.user$ = this.authService.userProfile$;
        console.log(this.user$);
        this.getData();
      }
    }
  }

  async setPassExpire() {
    const result = await this.authService.getPassExpired();

    if (result.isExpired) {
      this.isPassExpired = true;
    } else {
      this.isPassExpired = false;
    }
  }

  /**
   * Set selected language
   */
  setSelectedLanguage(): any {
    this.setLanguage(this.translationService.getSelectedLanguage());
  }

  setLanguage(lang: any) {
    this.languages.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
    this.translationService.setLanguage(lang);
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);

  }

  async getData() {

    const chkLogIn = await this.authService.hasLogined()
    if (chkLogIn == true) {
      const userData = await this.profileService.getUserDetail()
      this.item = userData
      if (this.item.userId != null) {
        const reAdChk = await this.serviceMu.authManual();
        this.isAdmin = reAdChk;
      }
      else {
        this.isAdmin = false
      }
    }
    else {
      this.isAdmin = false
    }
  }

  async logout() {
    await this.authService.logout()
    this.router.navigate(['/login'])
  }
}
